import React from 'react';
import { motion } from 'framer-motion';

const ManifestationBanner = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
      className="w-full relative"
    >
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-30"></div>
      
      <div className="max-w-5xl mx-auto py-6 px-6 text-center">
        <p className="font-lexend text-cream/70 text-[13px] md:text-sm leading-relaxed font-light">
          "A Friendship Pod Affair is not merely a novel; it is the encoded architecture of human resilience, building upon the foundations laid in <span className="text-gold font-medium">'You Are Smarter Than You Think'</span> <span className="text-gold/70 text-[9px] tracking-widest uppercase ml-1">(200k+ Students Impacted)</span>."
        </p>
      </div>
    </motion.div>
  );
};

export default ManifestationBanner;